import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const MedicineCompanyList = Loadable(
  lazy(() => import("./MedicineCompanyList")),
);
const MedicineCompanyForm = Loadable(
  lazy(() => import("./MedicineCompanyForm")),
);

const medicineCompanyRoutes = [
  {
    path: "/MedicineCompany/MedicineCompanyList",
    element: <MedicineCompanyList />,
    permission: PERMISSIONS.MedicineCompanies.Menu,
  },
  {
    path: "/MedicineCompany/MedicineCompanyForm",
    element: <MedicineCompanyForm />,
  },
  {
    path: "/MedicineCompany/MedicineCompanyForm/:medicineCompanyId",
    element: <MedicineCompanyForm />,
  },
];
export default medicineCompanyRoutes;
